export default __webpack_public_path__ + "static/media/doctor_11.99af4e80.svg";